// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";
import CopyToClipboard from "copy-to-clipboard";
import Button from "@mui/material/Button";

function WrappedShareButton(Props) {
  var player = Props.player;
  var set = TftSet.use(undefined);
  return React.createElement(Button, {
              onClick: (function (param) {
                  var url = encodeURI("https://tactics.tools" + Route.toString({
                            TAG: /* SetWrapped */4,
                            _0: set,
                            _1: player
                          }));
                  CopyToClipboard(url);
                  var cb = SnackbarService.sub.contents;
                  if (cb !== undefined) {
                    return Curry._1(cb, "Link copied to clipboard");
                  }
                  
                }),
              variant: "contained",
              color: "secondary",
              size: "small",
              children: "Share my profile"
            });
}

var make = WrappedShareButton;

export {
  make ,
  
}
/* Route Not a pure module */
